/*
 * [WEBSITE] Nerd Alert search (Randy 2026-10-20 (as) 9): "every word must narrow the results (AND), e.g. 'Spider-Man McFarlane
 * bronze'. Make eras, characters, creators and key words searchable. Show a live 'N books match' count that updates as I type.
 * Clearing the box must close the results list."
 * Shopify's own search pads its results with "related" books (it returned 1988-1990 McFarlane books for "bronze"), so the store
 * searches its own book index instead: /collections/all?view=na-index (templates/collection.na-index.liquid: title, cert, the
 * hidden comic.search_words the feed writes = era, year, characters, creators, publisher, grade, key words, short names).
 * A book matches when EVERY typed word matches one of its words: a word starts with it ("mcfar" finds McFarlane), a number must be
 * the whole word ("300" is not "3000"), "spider-man" = "spiderman" = "spider man". Sold books are never in the list.
 * The pure part (words / terms / matches / find) is also loaded by the runner's tests (module.exports at the bottom).
 */
(function (root) {
  'use strict';
  var norm = function (s) {
    return String(s === null || s === undefined ? '' : s).toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/&/g, ' and ').replace(/['’]/g, '');
  };

  /** A book's words (pure): every word, the parts of a hyphenated word and the parts joined ("spider-man" -> spider, man, spiderman). */
  function words(text) {
    var out = {};
    norm(text).split(/[^a-z0-9.\-\/#]+/).forEach(function (chunk) {
      var c = chunk.replace(/^[.#\-\/]+|[.\-\/]+$/g, '');
      if (!c) return;
      out[c.replace(/#/g, '')] = 1;
      var parts = c.split(/[\-\/#]+/).filter(Boolean);
      parts.forEach(function (p) { out[p.replace(/\.$/, '')] = 1; });
      if (parts.length > 1) out[parts.join('')] = 1;
    });
    delete out[''];
    return Object.keys(out);
  }

  /** The typed words (pure): "Spider-Man #300" -> ["spiderman", "300"]. */
  function terms(q) {
    return norm(q).split(/\s+/).map(function (t) {
      return t.replace(/^#+/, '').replace(/[\-\/]/g, '').replace(/^\.+|[.,;:!?"()]+$/g, '');
    }).filter(Boolean);
  }

  var isNum = function (t) { return /^\d+$/.test(t); };
  var hit = function (ws, t) {
    for (var i = 0; i < ws.length; i++) if (isNum(t) ? ws[i] === t : ws[i].indexOf(t) === 0) return true;
    return false;
  };

  /** Every typed word matches one of the book's words (pure). */
  function matches(book, ts) {
    if (!ts.length) return false;
    for (var i = 0; i < ts.length; i++) if (!hit(book.W, ts[i])) return false;
    return true;
  }

  /** One book of the index, ready to search (pure). */
  function prep(b) {
    var t = String(b.t || '');
    return Object.assign({}, b, { W: words(t + '\n' + (b.w || '') + '\n' + (b.s || '')), TW: words(t) });
  }

  /** The matching books (pure): books for sale first (the ones whose TITLE has the most typed words first, else the index order), then
   * sold books (Randy 2026-10-24: the same rules as the list pages: shown last, with the JUST SOLD stamp, no price, no heart). */
  function find(books, q) {
    var ts = terms(q);
    if (!ts.length) return [];
    var out = [];
    books.forEach(function (b, i) {
      if (!matches(b, ts)) return;
      var score = 0;
      ts.forEach(function (t) { if (hit(b.TW, t)) score++; });
      out.push({ b: b, score: score, i: i, sold: b.a === false ? 1 : 0 });
    });
    out.sort(function (x, y) { return x.sold - y.sold || y.score - x.score || x.i - y.i; });
    return out.map(function (x) { return x.b; });
  }

  var money = function (cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var esc = function (s) {
    return String(s === null || s === undefined ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };

  /** A result card, the same look as snippets/na-card.liquid. */
  function cardHtml(b) {
    var drop = b.dr && Number(b.c) > Number(b.p), sold = b.a === false;
    return '<a class="na-card' + (sold ? ' na-card--sold' : '') + '" href="' + esc(b.u) + '"><div class="na-card__img" style="position:relative;overflow:hidden">' +
      (b.i ? '<img src="' + esc(b.i) + '" alt="' + esc(b.t) + '" loading="lazy" width="360" height="566">' : '<span class="na-card__noimg"></span>') +
      (sold ? STAMP : '') +
      '</div><span class="na-card__title">' + esc(b.t) + '</span>' + (b.k ? '<span class="na-card__key">★ ' + esc(b.k) + '</span>' : '') +
      (sold ? '' : '<span class="na-card__price">' + (drop ? '<s>' + money(b.c) + '</s> ' : '') + money(b.p) + '</span>') + '</a>';
  }
  // the JUST SOLD stamp (same drawing as snippets/na-sold-stamp.liquid)
  var STAMP = '<svg class="na-stamp" viewBox="0 0 400 140" role="img" aria-label="Just sold"><defs>' +
    '<filter id="nsrS" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="0.165" numOctaves="4" seed="2" result="n"/>' +
    '<feColorMatrix in="n" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -12 8.2" result="h"/><feComposite in="SourceGraphic" in2="h" operator="in" result="i"/>' +
    '<feTurbulence type="turbulence" baseFrequency="0.035" numOctaves="2" seed="5" result="w"/><feDisplacementMap in="i" in2="w" scale="1.4"/></filter>' +
    '<filter id="nstS" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="0.16" numOctaves="4" seed="2" result="n"/>' +
    '<feColorMatrix in="n" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -12 8.9" result="h"/><feComposite in="SourceGraphic" in2="h" operator="in"/></filter></defs>' +
    '<rect x="18" y="18" width="364" height="104" fill="#fff" opacity="0.42" filter="url(#nsrS)"/>' +
    '<g filter="url(#nsrS)" fill="none" stroke="#161616" stroke-width="6" opacity="0.88"><path d="M14 14 H150 M196 14 H386 V68 M386 96 V126 H250 M210 126 H14 V82 M14 50 V14" stroke-linecap="square"/></g>' +
    '<text x="200" y="89" text-anchor="middle" fill="#161616" opacity="0.88" filter="url(#nstS)" font-family="Arial Black, Arial, sans-serif" font-size="56" font-weight="900" letter-spacing="5" stroke="#161616" stroke-width="1" textLength="340" lengthAdjust="spacing">JUST SOLD</text></svg>';

  var KEY = 'na-index-v2'; // v2: + pt (S-1025-09)
  var loading = null;
  /** The store's book index (browser only): every page of /collections/all?view=na-index, kept 10 minutes in this tab. */
  function load() {
    if (loading) return loading;
    loading = (async function () {
      try {
        var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (saved && Date.now() - saved.at < 600000 && Array.isArray(saved.books)) return saved.books.map(prep);
      } catch (e) { /* no storage: load fresh */ }
      var books = [], page = 1, pages = 1;
      do {
        var r = await fetch('/collections/all?view=na-index&page=' + page, { credentials: 'same-origin' });
        var j = JSON.parse(await r.text());
        books = books.concat(j.books || []);
        pages = Number(j.pages) || 1;
        page++;
      } while (page <= pages && page <= 40);
      try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), books: books })); } catch (e) { /* too big or blocked: fine */ }
      return books.map(prep);
    })();
    loading.catch(function () { loading = null; });
    return loading;
  }

  var api = { words: words, terms: terms, matches: matches, prep: prep, find: find, cardHtml: cardHtml, money: money, esc: esc, load: load };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NASearch = api;
})(typeof window !== 'undefined' ? window : this);
